import {svgIconWrapper} from '../svg-icon-wrapper';

import ShareRegular from './share-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ShareRegular {...validProps} />;
}

SvgComponent.iconName = 'shareRegular';

export const ShareRegularIcon = svgIconWrapper(SvgComponent);
